import { put, select, call } from 'redux-saga/effects';
import { selectCallSessions, setCallSessions, selectActiveCallId } from '../../../state/callSessions/callSessionsSlice';
import { syncYealinkWithCall } from '../../../utils/devices';

export default function* sessionsUpdated() {
  const sessions = yield select(selectCallSessions);
  yield put(setCallSessions([...sessions]));

  // Sync the active call state to Yealink headset when sessions update
  try {
    const activeCallId = yield select(selectActiveCallId);
    const activeCall = sessions.find((session) => session.id === activeCallId);

    if (activeCall) {
      yield call(syncYealinkWithCall, activeCall);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('sessionsUpdated - sync error:', error);
  }
}
